module.exports = __webpack_public_path__ + "img/logoF.a9786797.png";